import { loc } from "../../../../core/utils"
import React, { useEffect, useState } from "react"
import "./styles.scss"

const COUNTDOWN_SECONDS = 5

function ShopRedirectCountdown({ shopUrl, brandColor }) {
  const [secondsLeft, setSecondsLeft] = useState(COUNTDOWN_SECONDS)
  const accentColor = brandColor || "var(--brandColor, #007bff)"

  useEffect(() => {
    if (!shopUrl) return undefined

    let cancelled = false
    let secondsRemaining = COUNTDOWN_SECONDS

    const intervalId = window.setInterval(() => {
      secondsRemaining -= 1
      if (secondsRemaining <= 0) return
      if (!cancelled) setSecondsLeft(secondsRemaining)
    }, 1000)

    const timeoutId = window.setTimeout(() => {
      if (!cancelled) window.location.href = shopUrl
    }, COUNTDOWN_SECONDS * 1000)

    return () => {
      cancelled = true
      window.clearInterval(intervalId)
      window.clearTimeout(timeoutId)
    }
  }, [shopUrl])

  return (
    <div className="shop-redirect-countdown">
      <div className="shop-redirect-countdown__circle" aria-hidden="true" style={{ "--countdown-color": accentColor }}>
        <svg viewBox="0 0 36 36">
          <path
            className="shop-redirect-countdown__circle-bg"
            pathLength="100"
            d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
          />
          <path
            className="shop-redirect-countdown__circle-progress"
            pathLength="100"
            d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
          />
        </svg>
        <span className="shop-redirect-countdown__number">{secondsLeft}</span>
      </div>
      <p className="shop-redirect-countdown__message" aria-live="polite">
        {loc`Redirecting to Samsung shop shortly`}
      </p>
    </div>
  )
}

export default ShopRedirectCountdown
